import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioStructureFinanceExt } from '@/classes/scenario/ren-fr/structure-finance/ScenarioStructureFinanceExt';

const getDefaultFields = () => new ScenarioStructureFinanceExt();

export const buildStructureFinanceModule = () => {

  @Module({
    namespaced: true
  })
  class StructureFinanceModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioStructureFinanceExt {
      return this.getConfig.structure_finance ? new ScenarioStructureFinanceExt(this.getConfig.structure_finance) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return StructureFinanceModule;
};
